var J;

import {
  refresh,
  preUrl
} from 'x/route.js';

import split from 'x/split.js';

import removeSlash from 'x/removeSlash.js';

import setUrl from 'x/setUrl.js';

J = '#';

export default (url) => {
  var purl;
  url = removeSlash(url);
  purl = preUrl();
  if (url === purl) {
    return;
  }
  setUrl(url);
  if (split(url, J)[0] !== split(purl, J)[0]) {
    refresh(url);
  }
};
